const details = {
    name: "Jing Yang Fan",
    titles: ["Software Developer 💻", "Data Scientist 📊" , "Rock Climber 🧗‍♂️"],
    about: "Currently based in Toronto but open to relocating. I'm a life-long learner who loves discovering and tinkering with new technologies and turning my ideas into reality. Thanks for stopping by and I hope we can connect and get acquainted!"
}

export default details